import styled from "styled-components";
import { rem, em } from "convert-to-ems";

export const ProductTVValueElement = styled.div`
  min-width: ${rem(260)};
  height: ${rem(342)};
  margin-right: ${rem(8)};
  margin-left: ${rem(8)};
  padding-top: ${rem(18)};
  padding-left: ${rem(23)};
  border-radius: ${rem(8)};
  background-color: #fff;
  color: #000;
  box-shadow: ${rem(0)} ${rem(1)} ${rem(2)} #00000029;
  opacity: 1;
`;

export const ProductTVValueHeaderElement = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${rem(20)};
`;

export const ProductTVValueTVImgElement = styled.img`
  width: ${rem(24)};
  height: ${rem(21)};
`;

export const ProductTVValueTVNameElement = styled.span`
  margin-left: ${rem(16)};
  color: #000000;
  font-size: ${em(18)};
`;

export const ProductTVValueTVTextElement = styled.div`
  width: ${rem(190)};
  height: ${rem(31)};
  margin-top: ${rem(20)};
  margin-left: ${rem(1)};
  color: #000000;
  font-size: ${em(20)};
`;

export const ProductTVValueChannelsTextElement = styled.span`
  width: ${rem(26)};
  height: ${rem(31)};
  color: #e3252e;
  font-size: ${em(20)};
`;

export const ProductTVValueChannelsImgElement = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: ${rem(8)};
`;

export const ProductTVValuePriceElement = styled.div`
  margin-top: ${rem(20)};
  margin-left: ${rem(1)};
  font-size: ${em(32)};
`;

export const ProductTVValueValidateElement = styled.div`
  margin-top: ${rem(10)};
  margin-left: ${rem(1)};
  color: #5f646d;
  font-family: "Roboto";
  font-size: ${em(11)};
  opacity: 0.5;
`;

export const ProductTVImgRedeGloboElement = styled.img`
  width: ${rem(34)};
  height: ${rem(34)};
`;

export const ProductTVImgSportTVElement = styled.img`
  width: ${rem(40)};
  height: ${rem(8)};
`;

// atoms/ShowImagesPlanInitial

export const ProductTVImgBandElement = styled.img`
  width: ${rem(56)};
  height: ${rem(32)};
`;

export const ProductTVImgRecordElement = styled.img`
  width: ${rem(38)};
  height: ${rem(34)};
`;

export const ProductTVImgSbtElement = styled.img`
  width: ${rem(32)};
  height: ${rem(32)};
`;

// atoms/ShowImagesPlanLight

export const ProductTVImgDiscoveryKidsElement = styled.img`
  width: ${rem(40)};
  height: ${rem(36)};
`;

export const ProductTVImgStarChannelElement = styled.img`
  width: ${rem(40)};
  height: ${rem(24)};
`;

// atoms/ShowImagesPlanMix

export const ProductTVImgDiscoveryElement = styled.img`
  width: ${rem(40)};
  height: ${rem(8)};
`;

export const ProductTVImgMultishowElement = styled.img`
  width: ${rem(40)};
  height: ${rem(20)};
`;

export const ProductTVImgCartoonNetworkElement = styled.img`
  width: ${rem(40)};
  height: ${rem(24)};
`;

// atoms/ShowImagesPlanTop

export const ProductTVImgGloboNewsElement = styled.img`
  width: ${rem(40)};
  height: ${rem(10)};
`;

export const ProductTVImgHistoryElement = styled.img`
  width: ${rem(34)};
  height: ${rem(36)};
`;
